var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:_vm.classes,style:(_vm.style),attrs:{"type":_vm.type},on:{"click":function (e) { return _vm.$emit('click',_vm.classes); }}},'button',_vm.$props,false),[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }